var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-with-cover",class:[{ 'with-padding': _vm.formPadding }]},[_c('div',{staticClass:"cover"},[_vm._t("cover")],2),_c('div',{staticClass:"form"},[_vm._t("form")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }